// ─────────────────────────────────────────────────────────────────
// Glass-i — Customer Salesperson Mapping helpers (Stage HRMS-1).
// Pure JS — tested by the frontend node:test runner.
//
// Working-row shape adds `_new` (pending salesperson id) alongside the
// server `salespersonEmployeeId` (current). A row is dirty when they
// differ. Save sends only dirty rows.
// ─────────────────────────────────────────────────────────────────

export function normalizeMappingRows(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.map((r) => ({
    customerId:            r.customerId,
    customerCode:          r.customerCode || '',
    customerName:          r.customerName || '',
    gstin:                 r.gstin || '',
    city:                  r.city || '',
    state:                 r.state || '',
    salespersonEmployeeId: r.salespersonEmployeeId || null,
    salespersonName:       r.salespersonName || null,
    _new:                  r.salespersonEmployeeId || null
  }));
}

export function isRowDirty(row) {
  if (!row) return false;
  return (row._new || null) !== (row.salespersonEmployeeId || null);
}

export function setRowSalesperson(rows, customerId, empId) {
  if (!Array.isArray(rows)) return [];
  return rows.map((r) => r.customerId === customerId ? { ...r, _new: empId || null } : r);
}

// Apply a salesperson to many customerIds at once (bulk assign).
export function setManySalespersons(rows, customerIds, empId) {
  if (!Array.isArray(rows)) return [];
  const ids = new Set(Array.isArray(customerIds) ? customerIds : []);
  return rows.map((r) => ids.has(r.customerId) ? { ...r, _new: empId || null } : r);
}

export function dirtyCount(rows) {
  return (Array.isArray(rows) ? rows : []).filter(isRowDirty).length;
}

// Emits the { items } array for the bulk-save endpoint — dirty rows only.
export function buildMappingBulkItems(rows) {
  return (Array.isArray(rows) ? rows : [])
    .filter(isRowDirty)
    .map((r) => ({ customerId: r.customerId, salespersonEmployeeId: r._new || null }));
}

// In-memory filter so pending edits survive filter changes.
// opts: { search, salespersonId, unassignedOnly } — matches on the
// PENDING salesperson (_new) so filtering reflects the working state.
export function filterMappingRows(rows, opts = {}) {
  const list = Array.isArray(rows) ? rows : [];
  const needle = String(opts.search || '').trim().toLowerCase();
  const sp = opts.salespersonId || null;
  const unassignedOnly = opts.unassignedOnly === true;
  return list.filter((r) => {
    if (needle) {
      const hay = [r.customerCode, r.customerName, r.gstin, r.city, r.state]
        .map((v) => String(v || '').toLowerCase());
      if (!hay.some((v) => v.includes(needle))) return false;
    }
    if (unassignedOnly && (r._new || null) !== null) return false;
    if (sp && (r._new || null) !== sp) return false;
    return true;
  });
}
